<script>
export default {
  name: 'UserManagementSkeleton',
}
</script>

<template>
  <section>
    <v-skeleton-loader
      class="mb-4"
      height="40"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader height="40" type="button"></v-skeleton-loader>
  </section>
</template>
